import logo from './assets/logo.png'

const MAIN_SITE_URL = 'https://www.newsalist.net'
const VIDEOS_SITE_URL = 'https://videos.newsalist.net'

const QUICK_LINKS = [
  { label: 'الموقع الرئيسي', href: MAIN_SITE_URL },
  { label: 'فيديو', href: VIDEOS_SITE_URL },
  { label: 'للإعلان معنا', href: `${MAIN_SITE_URL}/contact` },
  { label: 'أنتم والحدث', href: `${MAIN_SITE_URL}/category/antm-walhdth/` },
  { label: 'الحدث', href: `${MAIN_SITE_URL}/category/alhdth/` },
  { label: 'إعرف أكثر', href: `${MAIN_SITE_URL}/category/iarf-akthr/` },
  { label: 'مقالات', href: `${MAIN_SITE_URL}/category/mqalat/` },
]

const SOCIAL_LINKS = [
  { label: 'واتساب', href: 'https://chat.whatsapp.com/GMEvPxxSgTg0dTyP1l3sqz', icon: 'WA' },
  { label: 'فيسبوك', href: 'https://www.facebook.com/profile.php?id=100087373202655', icon: 'f' },
  { label: 'تويتر', href: 'https://twitter.com/newsalist', icon: 'X' },
  { label: 'إنستغرام', href: 'https://www.instagram.com/newsalist', icon: 'IG' },
  { label: 'لينكدإن', href: 'https://www.linkedin.com/in/newsalist-net-664330255', icon: 'in' },
  { label: 'بريد إلكتروني', href: 'mailto:desk@newsalist.net', icon: '@' },
]

const Footer = () => {
  const year = new Date().getFullYear()
  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <div className="site-footer__brand-col">
          <img
            src={logo}
            alt="Newsalist"
            width={300}
            height={111}
            className="site-footer__logo"
          />
          <p className="site-footer__section">فلاش نيوز</p>
          <p className="site-footer__tagline">«&nbsp;لا تقف متفرجاً&nbsp;»</p>
          <p className="site-footer__rights">© {year}، كل الحقوق محفوظة.</p>
        </div>

        <div className="site-footer__col">
          <h2 className="site-footer__col-title">روابط سريعة</h2>
          <ul className="site-footer__list">
            {QUICK_LINKS.map((link) => (
              <li key={link.href}>
                <a href={link.href} className="site-footer__link" rel="noopener">
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="site-footer__col">
          <h2 className="site-footer__col-title">الشبكات الاجتماعية</h2>
          <ul className="site-footer__social">
            {SOCIAL_LINKS.map((s) => (
              <li key={s.href}>
                <a
                  href={s.href}
                  className="site-footer__social-link"
                  rel="noopener noreferrer"
                  target="_blank"
                  aria-label={s.label}
                  title={s.label}
                >
                  <span aria-hidden="true">{s.icon}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  )
}

export default Footer
